import axios from 'axios'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

export const getClientData = async (
  id: string
): Promise<GetClientData | { message: string }> => {
  try {
    const result = await apiService.get(`app/cliente/${id}`, {
      params: {
        id,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getUserData = async (): Promise<
  GetSendIvitationType | { message: string }
> => {
  try {
    const result = await apiService.get('/central/usuario/me')
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    // Desloga apenas quando a sessao e de fato invalida (401). Erros
    // transitorios (403/404/500/rede) nao devem derrubar uma sessao valida,
    // ainda mais agora que getUserData roda no mount de toda sessao.
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('X-TENANT-ID')
      window.location.href = '/'
    }
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getUserDataOrganization = async (
  tenantId: string
): Promise<GetUsersOrganizationType | { message: string }> => {
  try {
    const result = await apiService.get(
      `/central/usuario/organizacao/${tenantId}/me`
      // ,
      // {
      //   params: {
      //     tenantId,
      //   },
      // }
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
